import React from 'react';
import DatePicker from 'react-datepicker';
import FoldableSection from './FoldableSection';
import TimeSlotSelector from './TimeSlotSelector';

interface CalendarSectionProps {
    expanded: boolean;
    setExpanded: (expanded: boolean) => void;
    selectedDate: Date | null;
    setSelectedDate: (date: Date | null) => void;
    selectedTime: Date | null;
    setSelectedTime: (time: Date) => void;
    disabled?: boolean;
}

const CalendarSection: React.FC<CalendarSectionProps> = ({
    expanded,
    setExpanded,
    selectedDate,
    setSelectedDate,
    selectedTime,
    setSelectedTime,
    disabled = false
}) => {
    // Calculate available dates (next 30 days, excluding past dates)
    const today = new Date();
    const maxDate = new Date();
    maxDate.setDate(today.getDate() + 30);

    return (
        <FoldableSection
            title="Pilih Tanggal & Waktu"
            expanded={expanded}
            setExpanded={setExpanded}
            disabled={disabled}
            info={selectedDate && selectedTime && (
                <span>{`${selectedDate.toLocaleDateString()} jam ${selectedTime.getHours()}:00`}</span>
            )}
        >
            <div className="calendar-container">
                <div className="calendar-section">
                    <div className="calendar-heading">
                        <h3>{`Pilih tanggal:`}</h3>
                        <p className="calendar-hint">{`Sesi tersedia untuk 30 hari ke depan`}</p>
                    </div>
                    <div className="date-picker-container">
                        <DatePicker
                            selected={selectedDate}
                            onChange={(date) => !disabled && setSelectedDate(date)}
                            minDate={new Date(today.getTime() + 24 * 60 * 60 * 1000)} // 24 hours from now
                            maxDate={maxDate}
                            inline
                            filterDate={(date) => {
                                // Only allow weekdays that have available slots (Monday-Friday)
                                const weekday = date.getDay();
                                return weekday >= 1 && weekday <= 5;
                            }}
                            renderCustomHeader={({
                                date,
                                decreaseMonth,
                                increaseMonth,
                                prevMonthButtonDisabled,
                                nextMonthButtonDisabled,
                            }) => (
                                <div className="calendar-header">
                                    <button
                                        onClick={decreaseMonth}
                                        disabled={prevMonthButtonDisabled || disabled}
                                        className="month-nav prev"
                                    >
                                        ‹
                                    </button>
                                    <div className="month-display">
                                        {date.toLocaleDateString('ko-KR', { year: 'numeric', month: 'long' })}
                                    </div>
                                    <button
                                        onClick={increaseMonth}
                                        disabled={nextMonthButtonDisabled || disabled}
                                        className="month-nav next"
                                    >
                                        ›
                                    </button>
                                </div>
                            )}
                        />
                    </div>
                </div>

                <div className="time-section">
                    <div className="calendar-heading">
                        <h3>{`Pilih waktu:`}</h3>
                        <p className="calendar-hint">{`Semua waktu dalam zona waktu lokal Anda`}</p>
                    </div>
                    <div className="time-slots-container">
                        <TimeSlotSelector
                            selectedDate={selectedDate}
                            selectedTime={selectedTime}
                            setSelectedTime={setSelectedTime}
                            disabled={disabled}
                        />
                    </div>
                </div>
            </div>
        </FoldableSection>
    );
};

export default CalendarSection;